/* CR: the site's silent looping videos always play on their own (Carmen, 2026-10-19: "TODOS los videos de la web
   tienen que empezar por su propia cuenta y no debe aparecer esa flecha para darle play").
   1. Each silent loop is started when it comes into view, when the tab comes back and on the first touch; off
      screen it pauses.
   2. iPhones in Low Power Mode (and Safari set to never auto-play) refuse every video until a touch, and show a play
      arrow. There the video is swapped for the same MP4 shown as an image: Safari plays an MP4 in an <img> as it
      plays a GIF, on its own and looping, whatever the power mode. The arrow is hidden in layout/theme.liquid.
   Only muted looping videos without controls (banners, tiles, About, footer band, product gallery). Videos that load
   nothing until needed (snippets/cr-video, preload none) start loading here, 300 px before they reach the screen. */
(function () {
  var SEL = 'video[muted][loop]:not([controls]), video[autoplay][loop]:not([controls])';
  var APPLE = /Apple/.test(navigator.vendor || '');
  var seen = new WeakSet();
  var inView = new Set();
  function shown(v) { return v.isConnected && v.getClientRects().length > 0 && getComputedStyle(v).visibility !== 'hidden'; }

  // the MP4 for the image: on phones the largest quality up to 720 px, read from Shopify's stream playlist
  // (it lists every quality; the page only names the full one), so a phone doesn't download the 1080 file
  function mp4For(v, done) {
    var list = [].slice.call(v.querySelectorAll('source'));
    var mp4 = list.filter(function (x) { return /\.mp4/.test(x.getAttribute('src') || x.getAttribute('data-src') || ''); })[0];
    var full = mp4 ? (mp4.getAttribute('src') || mp4.getAttribute('data-src')) : (/\.mp4/.test(v.currentSrc) ? v.currentSrc : '');
    var hls = list.filter(function (x) { return /\.m3u8/.test(x.getAttribute('src') || ''); })[0];
    if (!hls || !window.fetch || !window.matchMedia('(max-width: 749px)').matches) { done(full); return; }
    var url = hls.getAttribute('src');
    fetch(url).then(function (r) { return r.text(); }).then(function (txt) {
      var best = null, bestSide = 0, lines = txt.split('\n');
      for (var i = 0; i < lines.length; i++) {
        var m = /RESOLUTION=(\d+)x(\d+)/.exec(lines[i]);
        var next = (lines[i + 1] || '').trim();
        var lab = /\.((?:HD|SD)-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8/.exec(next);
        if (!m || !lab) continue;
        var side = Math.min(+m[1], +m[2]);
        if (side <= 720 && side > bestSide) { bestSide = side; best = lab; }
      }
      if (!best) { done(full); return; }
      done(url.replace(/\.m3u8.*$/, '.' + best[1] + '-' + best[2] + '-' + best[3] + '.mp4'));
    }).catch(function () { done(full); });
  }

  // Safari only: the same file as an animated image, styled as the video was
  function asImage(v) {
    if (!APPLE || !v.isConnected || v.dataset.crImg) return;
    v.dataset.crImg = '1';
    mp4For(v, function (src) {
      if (!src || !v.isConnected) { delete v.dataset.crImg; return; }
      swap(v, src);
    });
  }
  function swap(v, src) {
    var cs = getComputedStyle(v);
    var img = document.createElement('img');
    img.className = (v.className ? v.className + ' ' : '') + 'cr-vimg';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.decoding = 'async';
    var st = img.style;
    st.objectFit = cs.objectFit;
    st.objectPosition = cs.objectPosition;
    var box = v.parentElement;
    if ((cs.position === 'absolute' || cs.position === 'fixed') && box) {
      // same place and size as the video, relative to its frame (so it follows a resize or a turned phone)
      st.position = cs.position;
      st.top = cs.top; st.left = cs.left; st.right = 'auto'; st.bottom = 'auto';
      st.width = 'calc(100% + ' + Math.round(parseFloat(cs.width) - box.clientWidth) + 'px)';
      st.height = 'calc(100% + ' + Math.round(parseFloat(cs.height) - box.clientHeight) + 'px)';
    } else {
      st.width = '100%';
      st.height = '100%';
    }
    st.zIndex = cs.zIndex === 'auto' ? '' : cs.zIndex;
    if (v.poster) st.background = 'url("' + v.poster + '") center / cover no-repeat';
    // a browser that can't show an MP4 as an image: back to the video, which shows its still frame (no arrow)
    img.onerror = function () { if (img.parentNode) img.parentNode.removeChild(img); v.style.display = ''; };
    img.src = src;
    inView.delete(v);
    if (io) io.unobserve(v);
    v.pause();
    v.style.display = 'none';
    v.parentNode.insertBefore(img, v);
  }

  function play(v) {
    if (!shown(v) || v.dataset.crImg) return;
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    if (!v.paused) return;
    var p = v.play();
    if (p && p.catch) p.catch(function (err) { if (err && err.name === 'NotAllowedError') asImage(v); });
    // some versions neither play nor refuse: still stopped after a moment on screen → image
    if (APPLE) setTimeout(function () { if (v.paused && inView.has(v) && !document.hidden) asImage(v); }, 1800);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { inView.add(e.target); play(e.target); }
      else { inView.delete(e.target); if (!e.target.paused) e.target.pause(); }
    });
  }, { rootMargin: '300px 0px' }) : null;
  function scan() {
    document.querySelectorAll(SEL).forEach(function (v) {
      if (seen.has(v)) return;
      seen.add(v);
      if (io) io.observe(v); else play(v);
    });
  }
  function retry() { inView.forEach(play); }
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  var queued = false;
  new MutationObserver(function () { if (queued) return; queued = true; setTimeout(function () { queued = false; scan(); }, 300); }).observe(document.documentElement, { childList: true, subtree: true });
  ['touchstart', 'pointerdown', 'keydown'].forEach(function (t) { window.addEventListener(t, retry, { passive: true }); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') retry(); });
})();
